import { useSelector } from "react-redux";

export const useChatState = () => {
  return {
    chatMessage: useSelector((s) => s.chat.chatMessage),
    threadChatMessage: useSelector((s) => s.chat.threadChatMessage),
    threadChatMessageObj: useSelector((s) => s.chat.threadChatMessageObj),
    isFetchingChatHistory: useSelector((s) => s.chat.isFetchingChatHistory),
    replyMessage: useSelector((s) => s.chat.replyMessage),
    progress: useSelector((s) => s.chat.progress),
    progressThread: useSelector((s) => s.chat.progressThread),
    selectedFileName: useSelector((s) => s.chat.selectedFileName),
    selectedFileType: useSelector((s) => s.chat.selectedFileType),
    selectedFileNameThread: useSelector((s) => s.chat.selectedFileNameThread),
    selectedFileTypeThread: useSelector((s) => s.chat.selectedFileTypeThread),
    imagePreviewOpen: useSelector((s) => s.chat.imagePreviewOpen),
    imagePreviewData: useSelector((s) => s.chat.imagePreviewData),
    userProfileId: useSelector((s) => s.chat.userProfileId),
    userProfileHoverId: useSelector((s) => s.chat.userProfileHoverId),
    sidebarActiveData: useSelector((s) => s.chat.sidebarActiveData),
    loaderActiveData: useSelector((s) => s.chat.loaderActiveData),
    searchChatData: useSelector((s) => s.chat.searchChatData),
    attendeeData: useSelector((s) => s.chat.attendeeData),
    deleteChatData: useSelector((s) => s.chat.deleteChatData),
    badWordList: useSelector((s) => s.chat.badWordList),
    loderAttendeeDirect: useSelector((s) => s.chat.loderAttendeeDirect),
    loaderAttendeeGroup: useSelector((s) => s.chat.loaderAttendeeGroup),
    unreadChatMessage: useSelector((s) => s.chat.unreadChatMessage),
    socketData: useSelector((s) => s.chat.socketData),
    isSocketConnected: useSelector((s) => s.chat.isSocketConnected),
    groupList: useSelector((s) => s.chat.groupList),
    attendeeList: useSelector((s) => s.chat.attendeeList),
    chatRoom: useSelector((s) => s.chat.chatRoom),
    searchAttendeeData: useSelector((s) => s.chat.searchAttendeeData),
    isUploadingData: useSelector((s) => s.chat.isUploadingData),
    attachmentData: useSelector((s) => s.chat.attachmentData),
    deletedMessageIds: useSelector((s) => s.chat.deletedMessageIds),
    isCursorOnUserProfile: useSelector((s) => s.chat.isCursorOnUserProfile),
    userProfilePopPosition: useSelector((s) => s.chat.userProfilePopPosition),
    msgMentionUser: useSelector((s) => s.chat.msgMentionUser),
    msgMentionId: useSelector((s) => s.chat.msgMentionId),
    isMentionInThread: useSelector((s) => s.chat.isMentionInThread),
    isChatHistoryEnableOnce: useSelector((s) => s.chat.isChatHistoryEnableOnce),
    selectedLanguage: useSelector((s) => s.chat.selectedLanguage),
    chatFilterLoader: useSelector((s) => s.chat.chatFilterLoader),
    popupClass: useSelector((s) => s.chat.popupClass),
    isScrollingUp: useSelector((s) => s.chat.isScrollingUp),
    selectedReactionUser: useSelector((s) => s.chat.selectedReactionUser),
    recentlyUsedEmoticon: useSelector((s) => s.chat.recentlyUsedEmoticon),
    desktopSystemStats: useSelector((s) => s.chat.desktopSystemStats),
    userStaticInfo: useSelector((s) => s.chat.userStaticInfo),
    chatSearchState: useSelector((s) => s.chat.chatSearchState),
    showPinnedMessage: useSelector((s) => s.chat.showPinnedMessage),
    pinnedChatMessages: useSelector((s) => s.chat.pinnedChatMessages),
    loaderPinnedChatData: useSelector((s) => s.chat.loaderPinnedChatData),
    loaderMorePinnedChatMessage: useSelector(
      (s) => s.chat.loaderMorePinnedChatMessage,
    ),
    hasMorePinnedChatMessage: useSelector(
      (s) => s.chat.hasMorePinnedChatMessage,
    ),
    showChatFiles: useSelector((s) => s.chat.showChatFiles),
    chatFiles: useSelector((s) => s.chat.chatFiles),
    loaderChatFilesData: useSelector((s) => s.chat.loaderChatFilesData),
    loaderMoreChatFiles: useSelector((s) => s.chat.loaderMoreChatFiles),
    jumpTargetMessage: useSelector((s) => s.chat.jumpTargetMessage),
    jumpTargetMessageThread: useSelector((s) => s.chat.jumpTargetMessageThread),
    chatboardSelectedTab: useSelector((s) => s.chat.chatboardSelectedTab),
    loaderSearchChatMessage: useSelector((s) => s.chat.loaderSearchChatMessage),
    searchedChatMessages: useSelector((s) => s.chat.searchedChatMessages),
    pinnedMessages: useSelector((s) => s.chat.pinnedMessages),
    filesMessages: useSelector((s) => s.chat.filesMessages),
    pinnedByUserProfileId: useSelector((s) => s.chat.pinnedByUserProfileId),
    hasMoreChatFiles: useSelector((s) => s.chat.hasMoreChatFiles),
    activeThreadChat: useSelector((s) => s.chat.activeThreadChat),
    unreadThreadListObj: useSelector((s) => s.chat.unreadThreadListObj),

    // phone support
    showPhoneSupport: useSelector((s) => s.chat.showPhoneSupport),
  };
};
